module.exports = __webpack_public_path__ + "static/media/objects_10.0ddebab2.svg";